const NewsTab = () => <p>News Tab</p>

export default NewsTab